import CGT from "../../utils/CGT.ts";
import {ActionIcon, Tooltip} from "@mantine/core";
import {CheckCircleIcon, CopyIcon, XCircleIcon} from "@phosphor-icons/react";
import {useContext} from "react";
import MessageContext from "../../context/MessageContext.tsx";
import {License, LicenseTransaction} from "../../types/general.types.ts";

export interface ColumnFieldOptions {
    field: string;
}


const TRUNCATED_ID_LENGTH = 6;

export const typeNames = {
    self: 'Personal',
    gift: 'Gift',
    voucher: 'Voucher',
    group: 'Faction License'
}

export const bodyType = (row: License) => {
    return typeNames[row.type];
}

export const transactionPayDateBody = (row: { payDate: number; }) => {
    if(row.payDate > 0) {
        const cgt = CGT.fromSeconds(row.payDate);
        return <div>{cgt.toCGT()}</div>
    } else {
        return <div className="text-red">Unpaid</div>
    }
}

export const bodyLicenseType = (row: LicenseTransaction) => {
    if(row.licenses.length === 0) {
        return <div>ERROR</div>
    }
    const type = row.licenses[0].type;
    return typeNames[type];
}
export const bodyTimestamp = (row: any, config: ColumnFieldOptions) => {
    if(row[config.field] > 0) {
        const cgt = CGT.fromSeconds(row[config.field]);
        return <span title={cgt.toLocaleString(CGT.DATETIME_SHORT)}>{cgt.toCGT()}</span>;
    }
}
export const bodyUser = (row: any, config: ColumnFieldOptions) => {
    return row[config.field]?.name;
}



export const bodyLicenseId = (row: License | LicenseTransaction, config: ColumnFieldOptions) => {
    const {success, error} = useContext(MessageContext);
    if(config.field in row) {
        // @ts-expect-error TS does not understand that config.field exists...
        const id = row[config.field] as string;
        if (!id) {
            return '';
        }
        const truncatedId = `${id.substring(0, TRUNCATED_ID_LENGTH)}...${id.substring(id.length - TRUNCATED_ID_LENGTH)}`;

        const copyToClipboard = () => {
            navigator.clipboard.writeText(id).then(() => {
                success('ID copied to clipboard');
            }).catch(err => {
                error('Error copying ID to clipboard', err.message);
            });
        };

        return (
            <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <Tooltip label="Copy ID">
                    <ActionIcon variant="subtle" size="sm" onClick={copyToClipboard}>
                        <CopyIcon size={16}/>
                    </ActionIcon>
                </Tooltip>
                <small title={id}>{truncatedId}</small>
            </div>
        );
    } else {
        return '';
    }
}

export const statusColor = {
    active: 'text-green',
    expired: 'text-red',
    cancelled: 'text-red',
    pending: 'text-yellow',
    available: 'text-cyan-500',
    redeemed: 'text-green'
}

export const bodyStatus = (row: License) => {
    // @ts-expect-error FUCK YOU TS
    const color = row.status in statusColor ? statusColor[row.status] : 'text-gray-500';
    return <span className={`capitalize ${color}`}>{row.status}</span>;
}

export const IconYes = () => <CheckCircleIcon size={16} color="var(--mantine-color-green-5)"/>;
export const IconNo = () => <XCircleIcon size={16} color="var(--mantine-color-gray-5)"/>;
